// extracted by mini-css-extract-plugin
export default {"table":"OpenPositions_table__YBZmN","tableContainer":"OpenPositions_tableContainer__NYO+k"};